module.exports = __webpack_public_path__ + "img/win.f5868007.svg";